module.exports = angular
    .module('lipsApp.translation', ['pascalprecht.translate', 'ngCookies'])
    .config(($translateProvider) => {
        $translateProvider
            .useStaticFilesLoader({
                prefix: '/app/translation/resources/',
                suffix: '.json'
            })
            .translations('rus', require('./resources/rus.json'))
            .translations('est', require('./resources/est.json'))
            .translations('eng', require('./resources/eng.json'))
            .useSanitizeValueStrategy('sanitizeParameters')
            .preferredLanguage('est')
            .fallbackLanguage('est');
    })
    .run(($rootScope, $translate, supportedLanguages) => {
        if(_.some(supportedLanguages, x => x.code == CURRENT_LANGUAGE)) {
          $translate.use(CURRENT_LANGUAGE);
        }

        $rootScope.getCurrentUiLanguageName = () => {
            const lang = $translate.proposedLanguage() || $translate.use();
            return _.get(_.find(supportedLanguages, {code: lang}), 'name', '');
        };
        $rootScope.getCurrentUiLanguageCode = () => {
            return $translate.proposedLanguage() || $translate.use();
        }
    })
    .constant('supportedLanguages', [
        {code: 'rus', name: 'RUS'},
        {code: 'est', name: 'EST'},
        {code: 'eng', name: 'ENG'}
    ]);



/** WEBPACK FOOTER **
 ** ./app/translation/translation.module.js
 **/